import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'numerals' })
export class NumeralsPipe implements PipeTransform {
  transform(number: number, exponent: Array<string>): string {
    const cases: Array<number> = [2, 0, 1, 1, 1, 2];
    return exponent[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]];
  }
}
